import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'
import { DateTime } from "luxon";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/calendar-component.PNG)

#### Content Type
nypwebc_ct_calendar
*/


@Component({
  tag: 'calendar-component',
  styleUrl: 'calendar-component.css',
  scoped: true
})
export class CalendarComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
  *Optional - number of items
  */
  @Prop() count: number = 1000;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"


  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link
 */
  @Prop() seeallurl: string;

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";
  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All"
  /**
 *Optional - single column display
 */
  @Prop() singlecolumn: boolean = false;

  @State() items: []
  @State() headeritems: []
  @State() isLoading: boolean = true;
  @State() modalShow: boolean = false;
  @State() modelBody
  @State() modelTitle


  handleClose = () => {


    this.modalShow = false
    this.modelBody = ""
    this.modelTitle = ""

  }

  handleShow = (event, body, title) => {

    console.log(body, title, event)

    let bodystring: string = ""
    let domNode: any;
    let bodyexist: boolean = false

    if (body != null) {
      bodystring = body;
      bodyexist = true;
      let parser = new DOMParser();
      domNode = parser.parseFromString(bodystring, "text/html");
      const img = domNode.querySelectorAll("img");
      const tables = domNode.querySelectorAll("table");

      for (let i = 0; i < img.length; i++) {
        img[i].classList.add("sc-calendar-component", "img-fluid", "rounded");
      }
      this.modelBody = domNode.body.innerHTML
    }



    this.modalShow = true
    // this.modelBody = domNode.body.innerHTML
    this.modelTitle = title


  }


  componentDidLoad() {

    let siteUrl: string = "";

    if (this.online) {
      siteUrl = this.siteurl + this.webpath
    }
    else {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }


    const d = new Date();


    const currentDateTime = d.getFullYear() + "-" +
      ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
      ("00" + d.getDate()).slice(-2) +
      "T00:00:00";

    let filter = "(nypwebc_StartDate ge datetime%27" + currentDateTime + "')"

    Promise.all([
      fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,nypwebc_ReadMore,Title,nypwebc_StartDate,nypwebc_EndDate,nypwebc_Description,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_StartDate&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } }).then(response => response.json()),
      fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ReadMore,nypwebc_StartDate,nypwebc_EndDate,nypwebc_Description,nypwebc_Body&$filter=Title eq 'XXHeaderXX'", { headers: { "Accept": "application/json; odata=verbose" } }).then(response => response.json())
    ])
      .then(([data, data2]) => {
        let xx = data.d.results
        let yy = data2.d.results
        // this.items = data.d.results.conact(data2.d.results);
        this.items = xx.concat(yy)
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
      });


    // https://infonet.nyp.org/hr/_api/web/lists/getbytitle('HRD_UpcomingEvents')/items?$select=ID,Title,nypwebc_StartDate,nypwebc_EndDate,nypwebc_Description,nypwebc_Body&$filter=Title eq 'XXHeaderXX'
    // return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_StartDate,nypwebc_EndDate,nypwebc_Description,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_StartDate&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })

    //   .then(response => response.json())
    //   .then(data => {
    //     this.items = data.d.results;
    //     this.isLoading = false;
    //   })



  }

  getHeader = () => {

    let headerDescription = ""
    this.items.forEach((item: any) => {
      if (item.Title === "XXHeaderXX") {
        headerDescription = <p style={{ margin: "10px 25px 10px 25px" }} innerHTML={item.nypwebc_Description}> </p>

      }
    });

    return headerDescription
  }
  getContents = (oe: any) => {

    const contentsArray = []


    this.items.forEach((item: any, index: any) => {
      let modalComponentId = "#modal" + this.componentid
      // let srcUrl = this.webpath + "/" + this.listname + "/" + item.FileLeafRef
      if (item.nypwebc_ReadMore) {

        if (item.Title !== "XXHeaderXX") {
          let day = DateTime.fromISO(item.nypwebc_StartDate).toLocaleString({ day: 'numeric' })
          let month = DateTime.fromISO(item.nypwebc_StartDate).toLocaleString({ month: 'short' })
          let cc1 = DateTime.fromISO(item.nypwebc_StartDate).toFormat('ccc t');
          let cc2 = DateTime.fromISO(item.nypwebc_EndDate).toFormat('t');
          let cc = cc1 + " - " + cc2

          if (oe === 0) {
            if (index % 2 === 0) {
              contentsArray.push(

                <div class="row mt-4">
                  <a href={item.nypwebc_ReadMore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" >

                    <div class="col-md-4 col-sm-12 card  fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                      <p class="monthday">{day}</p>
                      <p class="monthday">{month}</p>
                    </div>
                    <div class="col-md-8 col-sm-12">
                      <p>{item.Title}</p>
                      <p class="eventdate">{cc}</p>
                    </div>
                  </a>
                </div>

              )
            }
          }

          if (oe === 1) {
            if (index % 2 !== 0) {
              contentsArray.push(

                <div class="row mt-4">
                  <a href={item.nypwebc_ReadMore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" >
                    <div class="col-md-4 col-sm-12 fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                      <p class="monthday">{day}</p>
                      <p class="monthday">{month}</p>
                    </div>
                    <div class="col-md-8 col-sm-12">
                      <p>{item.Title}</p>
                      <p class="eventdate">{cc}</p>
                    </div>
                  </a>
                </div>

              )
            }
          }

          if (oe === 3) {
            contentsArray.push(
              <div class="row mt-4">
                <a href={item.nypwebc_ReadMore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" >
                  <div class="col-md-4 col-sm-12 fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                    <p class="monthday">{day}</p>
                    <p class="monthday">{month}</p>
                  </div>
                  <div class="col-md-8 col-sm-12">
                    <p>{item.Title}</p>
                    <p class="eventdate">{cc}</p>
                  </div>
                </a>
              </div>
            )
          }
        }

      }
      else {
        if (item.Title !== "XXHeaderXX") {
          let day = DateTime.fromISO(item.nypwebc_StartDate).toLocaleString({ day: 'numeric' })
          let month = DateTime.fromISO(item.nypwebc_StartDate).toLocaleString({ month: 'short' })
          let cc1 = DateTime.fromISO(item.nypwebc_StartDate).toFormat('ccc t');
          let cc2 = DateTime.fromISO(item.nypwebc_EndDate).toFormat('t');
          let cc = cc1 + " - " + cc2

          if (oe === 0) {
            if (index % 2 === 0) {
              contentsArray.push(

                <div class="row mt-4">
                  <a href='#'   onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" >

                    <div class="col-md-4 col-sm-12 card fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                      <p class="monthday">{day}</p>
                      <p class="monthday">{month}</p>
                    </div>
                    <div class="col-md-8 col-sm-12">
                      <p>{item.Title}</p>
                      <p class="eventdate">{cc}</p>
                    </div>
                  </a>
                </div>

              )
            }
          }

          if (oe === 1) {
            if (index % 2 !== 0) {
              contentsArray.push(

                <div class="row mt-4">
                  <a href='#'  onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" >
                    <div class="col-md-4 col-sm-12 fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                      <p class="monthday">{day}</p>
                      <p class="monthday">{month}</p>
                    </div>
                    <div class="col-md-8 col-sm-12">
                      <p>{item.Title}</p>
                      <p class="eventdate">{cc}</p>
                    </div>
                  </a>
                </div>

              )
            }
          }

          if (oe === 3) {
            contentsArray.push(
              <div class="row mt-4">
                
                <a href='#'  onClick={(event) => this.handleShow(event, item.nypwebc_Body, item.Title)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" >
                  <div class="col-md-4 col-sm-12 fw-bold card card-body text-center" style={{ backgroundColor: "whitesmoke" }}>
                    <p class="monthday">{day}</p>
                    <p class="monthday">{month}</p>
                  </div>
                  <div class="col-md-8 col-sm-12 ">
                    <p>{item.Title}</p>
                    <p class="eventdate">{cc}</p>
                  </div>
                </a>
              </div>
            )
          }
        }
      }
    })



    return contentsArray
  }

  render() {

    let modalComponentId = "modal" + this.componentid
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    let modalVisibilty = "modal"
    if (this.modalShow) {
      modalVisibilty = "modal show"
    }

    return (
      this.isLoading ? <loader-component />
        :
        this.header && this.items.length > 0 ?

          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0 pb-3 " style={parentstyle} >
              <div style={styleWithHeader} >
                <div class="p-3">
                  {this.getHeader()}
                  {this.singlecolumn ?
                    <div class="col-md-12">
                      {this.getContents(3)}
                    </div>
                    :
                    <div>
                      <div class="col-md-6 col-sm-12">
                        {this.getContents(0)}
                      </div>
                      <div class="col-md-6 col-sm-12">
                        {this.getContents(1)}
                      </div>
                    </div>
                  }
                </div>
            
                  </div>

              <div class="container">
                <div class={modalVisibilty} id={modalComponentId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={this.handleClose} aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <p > <div class="raw-html-style" innerHTML={this.modelBody} /> </p>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={this.handleClose}> Close</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style} >
              <div class="p-3">
                {this.getHeader()}

                {this.singlecolumn ?
                  <div class="col-md-12">
                    {this.getContents(3)}
                  </div>
                  :
                  <div>
                    <div class="col-md-6 col-sm-12">
                      {this.getContents(0)}
                    </div>
                    <div class="col-md-6 col-sm-12">
                      {this.getContents(1)}
                    </div>
                  </div>
                }
              </div>
            </div>


            <div class="container">
              <div class={modalVisibilty} id={modalComponentId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={this.handleClose} aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <p > <div class="raw-html-style" innerHTML={this.modelBody} /> </p>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={this.handleClose}> Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    )

  }
}

